import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { showLoading, hideLoading } from "./loading";
var axiosIns = axios.create({});
var defaultHeaders = new Headers({
  'Content-Type': 'application/json'
});
var CSRF_COOKIE_KEY = 'ctoken';
var CSRF_HEADER_KEY = 'x-csrf-token';
var csrfPromise;
var defaultXsfToken = {
  updateTime: Date.now(),
  value: ''
};

var filterRequestOpt = function filterRequestOpt(req) {
  var actualRequest = Object.assign({}, req);
  Reflect.deleteProperty(actualRequest, 'loading');
  return actualRequest;
};

var defaultOpt = {
  baseURL: '/',
  url: '',
  method: 'GET',
  loading: false,
  isHandleError: false
};

function isTokenUseFul() {
  return defaultXsfToken.value && defaultXsfToken.updateTime > Date.now() - 30 * 60 * 1000;
}

function mergeHeaders(options) {
  options.headers = _extends({}, defaultHeaders, options.headers || {}, {
    'x-xsrf-token': defaultXsfToken.value
  });
}

function isSafeMethod(method) {
  if (!method) {
    return false;
  }

  return !['POST', 'PUT', 'DELETE'].includes(method.toUpperCase());
}

var isMock = false;
var mockHost = '';
export function setMock(enabled, host) {
  isMock = enabled;
  mockHost = host;
}
fetch.setMock = setMock;
/**
 *
 * @param {*} options
 * @param isHandleError 页面中是否自定义处理异常
 * @param loading 接口是否展示loading
 */

function fetch(options) {
  options = _extends({
    url: '',
    method: 'POST',
    loading: false,
    isHandleError: false,
    inData: true,
    errorHanlder: null
  }, options); // merge 默认参数到 options

  mergeHeaders(options);

  if (isMock && options.mock !== false && !/^https?:/.test(options.url || '')) {
    options.url = mockHost + "/" + (options.url || '').replace(/^\/+/, '');
  }

  if (options.inData && options.data) {
    options.data = {
      data: options.data
    };
  } // mock 环境使用 fetch； 日常、预发、线上使用 asgard api


  if (!isSafeMethod(options.method)) {
    options = _extends({}, defaultOpt, options, {
      xsrfCookieName: CSRF_COOKIE_KEY,
      xsrfHeaderName: CSRF_HEADER_KEY
    });
  }

  if (options.loading) {
    showLoading();
  }

  var actualRequest = filterRequestOpt(options);
  var out = axiosIns(actualRequest)["finally"](function () {
    if (options.loading) {
      hideLoading();
    }
  });
  return out;
}

axiosIns.interceptors.response.use(function (response) {
  var res = response.data;

  if (res.error && res.error.message) {
    throw Error(res.error.message);
  }

  return res;
}, function (error) {
  return Promise.reject(error);
});
export default function (_x) {
  return _ref.apply(this, arguments);
}

function _ref() {
  _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
    var isExistCsrfPromise, tokenVal;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isTokenUseFul()) {
              _context.next = 7;
              break;
            }

            isExistCsrfPromise = typeof csrfPromise !== 'undefined';

            if (!isExistCsrfPromise) {
              csrfPromise = axiosIns({
                url: '/api/csrf',
                method: 'GET'
              });
            }

            _context.next = 5;
            return csrfPromise;

          case 5:
            tokenVal = _context.sent;

            if (tokenVal && tokenVal.token) {
              defaultXsfToken.value = tokenVal.token || '';
              defaultXsfToken.updateTime = Date.now();
            }

          case 7:
            return _context.abrupt("return", fetch(options));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _ref.apply(this, arguments);
}